import React, { useState, useEffect } from "react";
import styles from "../styles/ControlPanel.module.css";
 import { useStoredState } from "../customHooks/useStoredState";

function Timer({ timer, newGame, hasWon, moves, setIsCompeting, time, setTime }) {
  // const [time, setTime] = useStoredState(0, "storeTime");// in app
  //const [startTime, setStartTime] = useStoredState(0, "storeStartTime");
  const [startTime, setStartTime] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [isMilliseconds, setIsMilliseconds] = useState(false);

  useEffect(() => {
    if (moves >= 1 && !isActive && !hasWon) {
      setIsCompeting(false);
    }
  }, [moves, isActive]);
// start timer and counted in competing
  useEffect(() => {
    if (timer && moves == 1) {
      setIsActive(true);
      setIsCompeting(true);
    }
  }, [moves]);
//stop timer and save for immeadiate result
  useEffect(()=>{
    if(hasWon){
      const now = performance.now();
      setIsActive(false);
      const finalElapsed = now - startTime;
      setElapsedTime(finalElapsed);
      setTime(finalElapsed);
    } 
  },[hasWon]);

// starting timer
  useEffect(() => {
    let intervalId;
    const start = performance.now() - time;
    setStartTime(start);
    if (isActive) {
      //intervalId = setInterval(() => setTime((prevtime) => prevtime + 1), 1); //1000
      intervalId = setInterval(() => {
        const now = performance.now();
        setElapsedTime(now - start);
        setTime(now - start);
      }, 100);
    } else {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isActive]);//time

  useEffect(() => {
    if (newGame) {
      setTime(() => 0);
      setIsActive(false);
      setElapsedTime(0);
      setStartTime(0);
    }
  }, [newGame]);

const totalMilliseconds = Math.floor(time);
const hours = Math.floor(totalMilliseconds / 3600000);
const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
const seconds = Math.floor((totalMilliseconds % 60000) / 1000);
const hundreths = Math.floor((totalMilliseconds % 1000) / 10);
const milliseconds = totalMilliseconds % 1000;

  // const hours = Math.floor(time / 3600000);
  // const minutes = Math.floor((time % 3600000) / 60000);
  // const seconds = Math.floor((time % 60000) / 1000);
  // const milliseconds = time % 1000;
  
  // const hours = Math.floor(time / 3600);
  // const minutes = Math.floor((time % 3600) / 60);
  // const seconds = time % 60;

  // useEffect(() => {
  //   setIsActive(!isActive);
  // },[timerEnter]);

  function handleStartTimerClick() {
    if (!isActive) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }

  function handlePauseResetClick() {
    setIsActive(false);
    setTime(() => 0);
    setElapsedTime(0);
    setStartTime(0);
  }
  
  function handleTimerClick(){
    setIsMilliseconds(!isMilliseconds);
  }

  // so when user leaves page, timer stops, not handy now, may add timer restart when coming back onto page. using use ref. 
  // useEffect(() => {
  //   function handleVisibilityChange() {
  //     if (document.visibilityState === "hidden" && isActive) {
  //       // Pause the timer if the tab is hidden while active
  //       setIsActive(false);
  //     }
  //   }
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, [isActive]);

  return (
    <div className={styles.timerContainer}>
      {timer && (
        <button
          className={styles.startTimerButton}
          onClick={handleStartTimerClick}
        >
          {isActive ? "Pause" : "Start"}
        </button>
      )}
      {timer && (
        <button
          className={styles.pauseResetButton}
          onClick={handlePauseResetClick}
        >
          Reset
        </button>
      )}
      {timer && (
        <div className={styles.clockContainer}>
          <button title="Show milliseconds/hours" className={styles.clockTime} onClick={handleTimerClick}>
            {!isMilliseconds && hours.toString().padStart(2, "0") + ":"}
            {minutes.toString().padStart(2, "0")}:
            {seconds.toString().padStart(2, "0")}
            {isMilliseconds && ":" + milliseconds.toString().padStart(3, "0")}
          </button>
        </div>
      )}
      {timer && (
        <button className={styles.movesContainer}>Moves: {moves}</button>
      )}
    </div>
  );
}

export default Timer;
